import React from "react";
import LoadingScreen from "@/components/LoadingScreen";
import SmoothScroll from "@/components/SmoothScroll";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import BrandSeal from "@/components/BrandSeal";
import ManuscriptAtmosphere from "@/components/ManuscriptAtmosphere";
import {
  BotanicalTobaccoStudy,
  BlueprintCigar,
  MapMeridian,
  SmokeRibbon,
  WaxSealMark,
} from "@/components/ManuscriptPlates";
import Hero from "@/sections/Hero";
import ChapterHeritage from "@/sections/ChapterHeritage";
import ChapterLand from "@/sections/ChapterLand";
import ChapterJourney from "@/sections/ChapterJourney";
import ChapterCraft from "@/sections/ChapterCraft";
import ChapterCollection from "@/sections/ChapterCollection";
import ChapterArchive from "@/sections/ChapterArchive";
import ChapterWorkWithUs from "@/sections/ChapterWorkWithUs";
import ChapterInterlude from "@/sections/ChapterInterlude";

export default function HomePage() {
  return (
    <SmoothScroll>
      <LoadingScreen />
      <ManuscriptAtmosphere />
      <NavBar />
      <main data-testid="home-main" className="relative z-10">
        <Hero />
        <ChapterHeritage />

        {/* Interlude — into The Land */}
        <ChapterInterlude
          testid="interlude-land"
          topLeft="Interludium · I"
          topRight="Folio · 014"
          caption="A map of the southern valley."
          plate={<MapMeridian className="w-full h-auto" />}
          bg="bg-pearl"
        />

        <ChapterLand />

        {/* Interlude — into Seed to Smoke */}
        <ChapterInterlude
          testid="interlude-journey"
          topLeft="Interludium · II"
          topRight="Folio · 018"
          caption="Botanical study — Nicotiana tabacum."
          plate={<BotanicalTobaccoStudy className="w-full h-auto" />}
          bg="bg-pearl-warm"
        />

        <ChapterJourney />

        {/* Interlude — into Master Blender */}
        <ChapterInterlude
          testid="interlude-craft"
          topLeft="Interludium · III"
          topRight="Folio · 022"
          caption="A blueprint of the cigar."
          plate={<BlueprintCigar className="w-full h-auto" />}
          bg="bg-pearl"
        />

        <ChapterCraft />

        {/* Interlude — into The Final Cigar (slow smoke ribbons) */}
        <ChapterInterlude
          testid="interlude-collection"
          topLeft="Interludium · IV"
          topRight="Folio · 028"
          caption="The exhalation."
          plate={<SmokeRibbon className="w-full h-auto" />}
          bg="bg-pearl-warm"
        />

        <ChapterCollection />

        {/* Interlude — into The Archive (wax seal) */}
        <ChapterInterlude
          testid="interlude-archive"
          topLeft="Interludium · V"
          topRight="Folio · 034"
          caption="Sealed into the family ledger."
          plate={<WaxSealMark className="w-full h-auto" />}
          bg="bg-pearl"
        />

        <ChapterArchive />
        <ChapterWorkWithUs />
      </main>
      <Footer />
      <BrandSeal />
    </SmoothScroll>
  );
}
